import $ from "jquery";

const ContactAutoSuggest = (el) => {
    const $el = $(el);
    const $contactData = $el.find(".js-contact-data");
    const $coworkers = $contactData.data("value");

    const $autoComplete = $el.find(".auto-complete");

    const $searchInput = $el.find(".contact-search__input");
    const $hiddenField = $el.find("#hidden-field");

    const KEY_CODE_ARROW_DOWN = 40;
    const KEY_CODE_ARROW_RIGHT = 38;
    const KEY_CODE_ENTER = 13;

    let currentFocus;

    $($searchInput).on("input", function (e) {
        let $inputValue = $(this).val();
        closeList();

        if (!$inputValue) {
            return false;
        }

        currentFocus = -1;

        let $autoCompleteList = $("<ul>")
            .attr("id", "auto-complete-list")
            .addClass("auto-complete__list");

        for (let i = 0; i < $coworkers.length; i++) {
            const $hasMatch =
                $coworkers[i].substr(0, $inputValue.length).toUpperCase() ===
                $inputValue.toUpperCase();

            if ($hasMatch) {
                $autoComplete.append($autoCompleteList);

                let $autoCompleteItem = $("<li class='auto-complete__item'>");
                let $itemInner = $("<span class='auto-complete__item-inner'>");

                $autoCompleteItem.append($itemInner);

                $itemInner.html(
                    "<span class='auto-complete__match'>" +
                        $coworkers[i].substr(0, $inputValue.length) +
                        "</span>"
                );

                $itemInner.append($coworkers[i].substr($inputValue.length));

                $autoCompleteItem.append(
                    "<input class='hidden-input' type='hidden' value='" +
                        $coworkers[i] +
                        "'>"
                );

                $autoCompleteItem.on("click", function (e) {
                    const $hiddenValue = $(this).find(".hidden-input").val();

                    $searchInput.val($hiddenValue);
                    $hiddenField.val($hiddenValue.toLowerCase());
                    closeList();
                });

                $autoCompleteList.append($autoCompleteItem);
            } else {
                $hiddenField.val($inputValue.toLowerCase());
            }
        }
    });

    $($searchInput).on("keydown", function (e) {
        let $items = $("#auto-complete-list").find(".auto-complete__item");

        if (!$items) {
            return;
        }

        if (e.keyCode == KEY_CODE_ARROW_DOWN) {
            setActiveItem($items, 1);
        } else if (e.keyCode == KEY_CODE_ARROW_RIGHT) {
            setActiveItem($items, -1);
        } else if (e.keyCode == KEY_CODE_ENTER) {
            if (currentFocus > -1 && currentFocus < $items.length) {
                $items[currentFocus].click();
            }
        }
    });

    function setActiveItem(items, increment) {
        removeActiveItem(items);

        currentFocus += increment;

        if (currentFocus >= items.length) {
            currentFocus = 0;
        }

        if (currentFocus < 0) {
            currentFocus = items.length - 1;
        }

        $(items[currentFocus]).addClass("auto-complete__item--active");
    }

    function removeActiveItem(items) {
        for (let i = 0; i < items.length; i++) {
            $(items[i]).removeClass("auto-complete__item--active");
        }
    }

    function closeList(element) {
        let container = $(".auto-complete__list");

        for (let i = 0; i < container.length; i++) {
            if (element != container[i] && element != $searchInput) {
                container[i].parentNode.removeChild(container[i]);
            }
        }
    }

    $(document).on("click", function (e) {
        const $shouldCloseList =
            !$searchInput.is(e.target) &&
            $searchInput.has(e.target).length === 0;

        if (!$shouldCloseList) {
            return;
        }

        closeList(e.target);
    });
};

export default ContactAutoSuggest;
